
  import { defineComponent, ref, computed, onMounted } from 'vue';
  import { useStore } from 'vuex';
  import { Actions } from '@/store/enums/StoreEnums';
  import { useI18n } from 'vue-i18n/index';

  export default defineComponent({
    name: 'home-services-filter',
    emit: ['type-selected', 'reset'],
    setup(_, { emit }) {
      const { t, te } = useI18n();
      const store = useStore();

      const selectedItems = ref<any>({
        version: '',
        description: '',
      });

      const translate = (text: string) => (te(text) ? t(text) : text);

      const onSubmit = async () => {
        await store.dispatch(
          Actions.UPDATE_HOME_SERVICES_FILTER,
          selectedItems.value
        );
        emit('type-selected', selectedItems.value);
      };

      const onReset = async () => {
        selectedItems.value = {
          version: '',
          description: '',
        };
        await store.dispatch(
          Actions.UPDATE_HOME_SERVICES_FILTER,
          selectedItems.value
        );
        emit('reset', selectedItems.value);
      };

      const filter = computed(() => store.getters.getHomeServicesFilter || {});
      onMounted(() => {
        if (
          filter.value?.description &&
          filter.value.description !== 'undefined'
        )
          selectedItems.value.description = filter.value.description;
        if (filter.value?.version && filter.value.version !== 'undefined')
          selectedItems.value.version = filter.value.version;
      });

      return { selectedItems, onSubmit, onReset, translate };
    },
  });
